module.exports = __webpack_public_path__ + "img/s6_img-s.c829b5dc.png";